"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _rxjs = require("rxjs");

var _lodash = _interopRequireDefault(require("lodash"));

var _operators = require("rxjs/operators");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = function _default(isProductionVar, shouldLogVar) {
  var _ref, _process, _process$env, _ref2, _process2, _process2$env, _process3, _process3$env;

  var isProduction = (_ref = isProductionVar !== null && isProductionVar !== void 0 ? isProductionVar : ((_process = process) === null || _process === void 0 ? void 0 : (_process$env = _process.env) === null || _process$env === void 0 ? void 0 : _process$env.NODE_ENV) === 'production') !== null && _ref !== void 0 ? _ref : true;
  var shouldLog = (_ref2 = shouldLogVar !== null && shouldLogVar !== void 0 ? shouldLogVar : (_process2 = process) === null || _process2 === void 0 ? void 0 : (_process2$env = _process2.env) === null || _process2$env === void 0 ? void 0 : _process2$env.LOG_STORE) !== null && _ref2 !== void 0 ? _ref2 : (_process3 = process) === null || _process3 === void 0 ? void 0 : (_process3$env = _process3.env) === null || _process3$env === void 0 ? void 0 : _process3$env.REACT_APP_LOG_STORE; //import StartingValues from '../StartingValues'

  var setObject = function setObject(object, keypath, value) {
    var tempObject = _lodash["default"].cloneDeep(object);

    var oldValue = _lodash["default"].get(tempObject, keypath);

    var oldValueFixed = oldValue ? oldValue : {};
    return _lodash["default"].set(tempObject, keypath, _objectSpread(_objectSpread({}, oldValueFixed), value));
  };

  var dispatch;

  var log = function log(text) {
    if (!isProduction) {
      if (text === 'store') {
        console.log("%cStore:", 'background: red; color: white');
      } else if (text === 'update') {
        console.log("%cUpdate:", 'background: blue; color: white');
      } else {
        console.log(text);
      }
    }
  };

  var update$ = _rxjs.Observable.create(function (observer) {
    dispatch = function dispatch(action) {
      return observer.next(action);
    };
  }).pipe( // Forces every value to get rendered before next value is calculated
  (0, _operators.observeOn)(_rxjs.queueScheduler));

  var Store = update$.pipe((0, _operators.tap)(function (e) {
    return !isProduction && shouldLog ? log('update') : null;
  }), (0, _operators.tap)(function (e) {
    return !isProduction && shouldLog ? log(e({})) : null;
  }), // If null, use previous
  (0, _operators.scan)(function (acc, next) {
    var _next;

    return (_next = next(acc)) !== null && _next !== void 0 ? _next : acc;
  }, {}), (0, _operators.tap)(function (e) {
    return !isProduction && shouldLog ? log('store') : null;
  }), (0, _operators.tap)(function (e) {
    return !isProduction && shouldLog ? log(e) : null;
  }), (0, _operators.startWith)({}), (0, _operators.shareReplay)(1));
  Store.subscribe(function (event) {});

  var getState = function getState() {
    var keypath = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    if (_lodash["default"].isNil(keypath)) {
      return Store;
    } else {
      return Store.pipe((0, _operators.mergeMap)(function (e) {
        var unstarredId = keypath.replace('.*', '');

        var value = _lodash["default"].get(e, unstarredId);

        if (keypath.substring(keypath.length - 2, keypath.length) === '.*') {
          return (0, _rxjs.from)(Object.keys(value).map(function (e) {
            return {
              id: e,
              value: {
                id: e,
                value: value[e]
              }
            };
          }));
        } else {
          return (0, _rxjs.of)({
            id: null,
            value: value
          });
        }
      }), (0, _operators.groupBy)(function (e) {
        return e.id;
      }), (0, _operators.mergeMap)(function (group) {
        return group.pipe((0, _operators.map)(function (object) {
          return object.value;
        }), (0, _operators.distinctUntilChanged)(function (a, b) {
          return _lodash["default"].isEqual(a, b);
        }));
      }), (0, _operators.filter)(function (e) {
        return !_lodash["default"].isUndefined(e);
      }));
    }
  };

  var getStateUndefined = function getStateUndefined() {
    var keypath = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    if (_lodash["default"].isNil(keypath)) {
      return Store;
    } else {
      return Store.pipe((0, _operators.mergeMap)(function (e) {
        var unstarredId = keypath.replace('.*', '');

        var value = _lodash["default"].get(e, unstarredId);

        if (keypath.substring(keypath.length - 2, keypath.length) === '.*') {
          return (0, _rxjs.from)(Object.keys(value).map(function (e) {
            return {
              id: e,
              value: {
                id: e,
                value: value[e]
              }
            };
          }));
        } else {
          return (0, _rxjs.of)({
            id: null,
            value: value
          });
        }
      }), (0, _operators.groupBy)(function (e) {
        return e.id;
      }), (0, _operators.mergeMap)(function (group) {
        return group.pipe((0, _operators.map)(function (object) {
          return object.value;
        }), (0, _operators.distinctUntilChanged)(function (a, b) {
          return _lodash["default"].isEqual(a, b);
        }));
      }));
    }
  };

  var nextState = function nextState(key, value) {
    return dispatch(function (acc) {
      // Check to make sure new value is different from existing value
      if (!_lodash["default"].isEqual(_lodash["default"].get(acc, key), value)) {
        // Clone for dev, otherwise set directly for speed
        return !isProduction ? _lodash["default"].set(_lodash["default"].cloneDeep(acc), key, value) : _lodash["default"].set(acc, key, value);
      } else {
        // Return null if no changes
        return null;
      }
    });
  };

  var mergeState = function mergeState(key, value) {
    return dispatch(function (acc) {
      return setObject(acc, key, value);
    });
  }; //_.cloneDeep({...acc, [key]: { ...acc[key], ...value }}))
  // keypath.split('.').reduce((acc, next) => ({...acc, [next]: acc[next] ? {...acc[next]} : {} }))
  //scan((acc, next) => ({...acc, [next.key]: _.merge({}, acc[next.key], { [next.id]: next.value })}), {}),


  return {
    mergeState: mergeState,
    nextState: nextState,
    getStateUndefined: getStateUndefined,
    getState: getState
  };
};

exports["default"] = _default;
//# sourceMappingURL=Store.js.map